const debounce = require('lodash.debounce');

let initialHash = "";

function changeAmp(name) {
  let hash = window.location.hash;
  let splittedHash = hash.split("#");
  if(splittedHash[2] === name ) return;
  splittedHash[2] = name;
  hash = splittedHash.join('#')
  window.location.hash = hash;
}

export function setInitialHash(hash) {
  initialHash = hash;
}

export function getInitialHash() {
  return initialHash;
}

export function getInitialSection() {
  return initialHash.split('#')[2]
}

export const setAmp = debounce(changeAmp, 30);
